import { Accordion } from "@mui/material";
import { useState } from "react";

import useService from "../../../../../../hooks/useService";
import CustomFollowUpHistoryAccordionDetails from "../Accordion/CustomFollowUpHistoryAccordionDetails";
import CustomFollowUpHistoryAccordionSummary from "../Accordion/CustomFollowUpHistoryAccordionSummary";

export default function FollowUpHistoryListItem({ data }) {
  const actionableItemsRepository = useService("repositories/actionable-items-repository");
  const [isLoading, setIsLoading] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [selectedItem, setSelectedItem] = useState();

  const fetchData = async (id) => {
    setIsLoading(true);
    try {
      const responseObj = await actionableItemsRepository.findRecord(id, { noCache: true });
      setSelectedItem(responseObj);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleToggle = (id) => {
    if (!expanded) {
      fetchData(id);
    }
    setExpanded(!expanded);
  };

  return (
    <Accordion
      disableGutters
      elevation={0}
      sx={{
        "&::before": { display: "none" },
      }}
      onChange={() => handleToggle(data.id)}
    >
      <CustomFollowUpHistoryAccordionSummary data={data} />
      <CustomFollowUpHistoryAccordionDetails data={selectedItem} loading={isLoading} />
    </Accordion>
  );
}
